import { Link } from 'react-router-dom';
import { useMyOutstanding, rupees } from '../dashboard/executive/myDayData';
import { QueryState } from '../dashboard/executive/MyDaySections';

export function MyOutstandingPage() {
  const query = useMyOutstanding();
  return <div className="space-y-5">
    <header>
      <h1 className="text-2xl font-semibold">My Outstanding</h1>
      <p className="text-sm text-[var(--ink-3)]">Remaining unpaid balances on orders you created.</p>
    </header>
    {!query.data ? <QueryState label="My Outstanding" error={query.error} retry={query.retry} /> : <>
      <div className="card p-4">
        <span>Total outstanding</span>
        <strong className="block text-2xl">{rupees(query.data.total)}</strong>
      </div>
      {query.data.rows.length === 0 ? <p>No unpaid orders.</p> : <div className="card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr>{['Order', 'Customer', 'Order date', 'Order amount', 'Paid', 'Remaining balance'].map(h => <th key={h} className="p-3 text-left">{h}</th>)}</tr>
          </thead>
          <tbody>{query.data.rows.map(row => <tr key={row.id} className="border-t">
            <td className="p-3">
              <Link to="/sales-orders" className="underline">{row.number}</Link>
            </td>
            <td className="p-3">{row.customer || 'Name not recorded'}</td>
            <td className="p-3">{new Date(row.orderDate).toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata' })}</td>
            <td className="p-3">{rupees(row.amount)}</td>
            <td className="p-3">{rupees(row.paid)}</td>
            <td className="p-3">{rupees(row.balance)}</td>
          </tr>)}</tbody>
        </table>
      </div>}
    </>}
  </div>;
}
